import React from 'react';
import { Paragraph } from '../../../../components';
import './FormIntroduction.scss';

export const FormIntroduction = () => {
    return (
        <div className="form-intro">
            <Paragraph className="form-intro__text">
                The Migration Appliance Instance will be launched into your target cloud (destination environment). It
                must remain running for the duration of all migration activity, through final sync.
            </Paragraph>
        </div>
    );
};

